<spr-section-title
	[isStarted]="isStarted"
	[section]="section"
></spr-section-title>
<spr-section-module
	*ngFor="let module of modules; trackBy: trackByModule"
	[module]="module"
	[routerLink]="module.routerLink"
	[section]="section"
></spr-section-module>
<spr-section-progress [progress]="progress"></spr-section-progress>
